/** @flow */
import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { List, ListItem } from 'material-ui/List';
import { translate } from 'react-i18next';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import CurrentAdvertiserHeader from '../modules/advertiser/CurrentAdvertiserHeader';

const Link = styled(NavLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primaryText};
`;

const ExternalLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primaryText};
`;

const activeStyle = theme => ({
  color: theme.colors.primary,
});

type Props = {
  onLinkClick: () => void,
  theme: any,
  t: any,
};

function Menu(props: Props) {
  const {
      t, onLinkClick, theme,
    } = props;
  const activeStyleTheme = activeStyle(theme);

  return (
    <div>
      <CurrentAdvertiserHeader />
      <List>
        <Link to="/dashboard" activeStyle={activeStyleTheme} onClick={onLinkClick}>
          <ListItem primaryText={t('menu.dashboard')} style={{ color: 'inherit' }} leftIcon={<i className="material-icons">dashboard</i>} />
        </Link>
        <Divider style={{ marginTop: theme.metrics.smallMargin }} />
        <Subheader>{t('menu.campaigns')}</Subheader>
        <Link to="/campaigns/proposed" activeStyle={activeStyleTheme} onClick={onLinkClick}>
          <ListItem primaryText={t('menu.proposedCampaigns')} style={{ color: 'inherit' }} leftIcon={<i className="material-icons">view_list</i>} />
        </Link>
        <Link to="/campaigns/purchased" activeStyle={activeStyleTheme} onClick={onLinkClick}>
          <ListItem primaryText={t('menu.purchasedCampaigns')} style={{ color: 'inherit' }} leftIcon={<i className="material-icons">poll</i>} />
        </Link>
        <Divider style={{ marginTop: theme.metrics.smallMargin }} />
        <Link to="/tutorials" activeStyle={activeStyleTheme} onClick={onLinkClick}>
          <ListItem primaryText={t('menu.tutorials')} style={{ color: 'inherit' }} leftIcon={<i className="material-icons">school</i>} />
        </Link>
        <ExternalLink href="http://follo.ca" target="_blank" rel="noopener noreferrer" activeStyle={activeStyleTheme} onClick={onLinkClick}>
          <ListItem primaryText={t('menu.methodology')} style={{ color: 'inherit' }} leftIcon={<i className="material-icons">data_usage</i>} />
        </ExternalLink>
      </List>
    </div>
  );
}

export default withRouter(withTheme(translate()(Menu)));



// WEBPACK FOOTER //
// ./src/advertisers/layout/Menu.js